import { useQuery } from '@tanstack/react-query';
import { endpoints, getIDFromUrl, Url } from '@rossum/api-client';
import { useApiClient } from '../../../lib/apiClient';

const QUERY_KEY_RULE_EMAIL_TEMPLATES = 'rule-email-templates';

export const useRuleEmailTemplatesByQueues = (queues: Url[]) => {
  const api = useApiClient();
  return useQuery({
    queryKey: [QUERY_KEY_RULE_EMAIL_TEMPLATES, queues] as const,
    queryFn: () =>
      api.unpaginatedRequest(endpoints.emailTemplates.list)({
        queue: queues.map(getIDFromUrl),
      }),
    enabled: queues.length > 0,
  });
};
